import { useEffect, useState } from "react";
import { TextInput, Flex } from "@mantine/core";
import { useDebouncedValue } from "@mantine/hooks";
import { DataTable } from "mantine-datatable";

import { IconSearch } from "@tabler/icons-react";
import { PAGE_SIZE } from "CommonData";

//const PAGE_SIZE = 10;
// window.PAGE_SIZE = 20;   // 240123 by LEE, ?? ?????? ???

function SRD_DataTable(props) {
  const {
    data,
    columns,
    registerButton,
    idAccessor,
    selectedRecords,
    setSelectedRecords,
    searchBar,
    page,
    setPage,
    isRecordSelectable,
  } = props;

  const [records, setRecords] = useState(data);

  const [query, setQuery] = useState("");
  const [debouncedQuery] = useDebouncedValue(query, 200);
  const [initialize, setInitialize] = useState(true);

  const isFetching =
    typeof data === "undefined" || data === null ? true : false;

  const totalRecords = data?.[0]?.page_cnt ?? data?.length;

  useEffect(() => {
    if (data) {
      setRecords(
        Object.values(data).filter((obj) => {
          return Object?.values(obj).some((val) => {
            if (
              typeof val === "string" &&
              val.includes(debouncedQuery.trim())
            ) {
              return true;
            }
            return false;
          });
        })
      );
    }
    if (query === "") setInitialize((prev) => !prev);
  }, [debouncedQuery, data]);

  
  return (
    <>
      {searchBar ? (
        searchBar
      ) : (
        <Flex
          align="center"
          mb="md"
          style={{ justifyContent: "space-between" }}
        >
          <TextInput
            sx={{ flexBasis: "60%" }}
            placeholder=""
            icon={<IconSearch size={16} />}
            value={query}
            onChange={(e) => setQuery(e.currentTarget.value)}
          />
          {registerButton}
        </Flex>
      )}

      <DataTable
        withBorder
        borderRadius="sm"
        withColumnBorders
        highlightOnHover
        minHeight={300}
        height={"90%"}
        records={records ? records : []}
        noRecordsText="No records to show"
        columns={columns ?? []}
        totalRecords={totalRecords}
   //     recordsPerPage={PAGE_SIZE}
        recordsPerPage={!data?.[0]?.page_cnt ? data?.length : PAGE_SIZE}
        page={page}
        onPageChange={setPage}
        onCellClick={(e) => {
          if (e.column.onClick) e.column.onClick(e);
        }}
        selectedRecords={idAccessor ? selectedRecords : null}
        onSelectedRecordsChange={setSelectedRecords}
        idAccessor={idAccessor}
        fetching={isFetching}
        isRecordSelectable={isRecordSelectable}
      />
    </>
  );
}

export default SRD_DataTable;

